import {UpdateQueryOptions} from "../../../../common/state/query.actions";

export class UpdateInventoryBillingQuery {
  static readonly type = '[INVENTORY_BILLING] Update Query';

  constructor(public options?: UpdateQueryOptions) {
  }
}

export class UpdateInventoryBillingActiveSiderSection {
  static readonly type = '[INVENTORY_BILLING] Update active sider section';
  constructor(public name: string) {}
}
